<template>
    <section class="title">
        <h3>{{ title }}</h3>
        <Divider v-if="withDivider" :color="config.COLOR_PRIMARY"/>
        <p v-if="description" v-html="htmlDescription"/>
    </section>
</template>
<script>
import { SolutionConsumer } from '../../mixins';

export default {
    name: 'SectionTitle',
    mixins: [SolutionConsumer],
    props: {
        title: {
            type: String,
            default: '',
        },
        description: {
            type: String,
            default: '',
        },
        withDivider: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        htmlDescription () {
            return this.description.replace(/(\w+@\w+\.\w+)/g, '<a href="mailto:$1">$1</a>');
        },
    },
};
</script>
<style lang="scss" scoped>
section.title {
    text-align: center;

    > h3 {
        margin: 0;

        /* Apply margin only if <p> is direct sibling (no divider between them) */
        & + p {
            margin-top: 16px;
        }
    }

    > p {
        margin: 0;
    }
}
</style>
